import { useRef } from 'react'

/**
 * Создание статьи (ручное или автосохранением) меняет адрес на её slug, и засев
 * сервера приезжает не сразу. Раньше на это время вместо формы вставал гейт
 * загрузки: форма размонтировалась — выглядело как перезагрузка страницы, а
 * набранное во время запроса терялось. На переходе «новая → созданная» отдаём
 * прежний засев, пока не приедет новый; тот вливается ребейзом формы, как после
 * любого сохранения. Открытие ДРУГОЙ статьи держания не получает — там гейт честный.
 */
export const useSeedAcrossCreate = <T>(slug: string | undefined, seed: T | null): T | null => {
  const prevSlug = useRef(slug)
  const justCreated = useRef(false)
  if (prevSlug.current !== slug) {
    justCreated.current = prevSlug.current === undefined && slug !== undefined
    prevSlug.current = slug
  }
  const lastSeed = useRef(seed)
  if (seed) lastSeed.current = seed
  return seed ?? (justCreated.current ? lastSeed.current : null)
}
